import { AdminInput, AdminToggle, AdminSelect, AdminTextarea, AdminSectionCard } from './AdminFormInput';
import ImagePicker from '@/components/ImagePicker';
import type { TemplateConfig } from '@/mocks/template-config';

interface PDFFormProps {
  cover: TemplateConfig['cover'];
  backCover: TemplateConfig['backCover'];
  pdf: TemplateConfig['pdf'];
  onChangeCover: (config: TemplateConfig['cover']) => void;
  onChangeBackCover: (config: TemplateConfig['backCover']) => void;
  onChangePdf: (config: TemplateConfig['pdf']) => void;
}

export default function PDFForm({ cover, backCover, pdf, onChangeCover, onChangeBackCover, onChangePdf }: PDFFormProps) {
  return (
    <div className="space-y-5">
      <AdminSectionCard title="Configurações do PDF" icon="ri-file-settings-line">
        <AdminToggle
          label="Numerar Páginas"
          checked={pdf.includePageNumbers}
          onChange={(v) => onChangePdf({ ...pdf, includePageNumbers: v })}
        />
        <p className="text-brand-text-muted text-xs">
          Quando ativado, exibe "Página X de Y" no rodapé de cada página do PDF.
        </p>
      </AdminSectionCard>

      <AdminSectionCard title="Capa do PDF" icon="ri-file-pdf-line">
        <AdminToggle
          label="Capa Ativada"
          checked={cover.enabled}
          onChange={(v) => onChangeCover({ ...cover, enabled: v })}
        />
        <ImagePicker
          label="Imagem da Capa"
          value={cover.image}
          onChange={(url) => onChangeCover({ ...cover, image: url })}
          type="template"
          category="pdf-cover"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <AdminInput
            label="Título da Capa"
            value={cover.title}
            onChange={(e) => onChangeCover({ ...cover, title: e.target.value })}
          />
          <AdminInput
            label="Subtítulo da Capa"
            value={cover.subtitle}
            onChange={(e) => onChangeCover({ ...cover, subtitle: e.target.value })}
          />
        </div>
        <AdminSelect
          label="Overlay"
          value={cover.overlay}
          onChange={(e) => onChangeCover({ ...cover, overlay: e.target.value as 'dark' | 'light' | 'none' })}
          options={[
            { value: 'dark', label: 'Escuro' },
            { value: 'light', label: 'Claro' },
            { value: 'none', label: 'Nenhum' },
          ]}
        />
      </AdminSectionCard>

      <AdminSectionCard title="Contracapa do PDF" icon="ri-book-open-line">
        <AdminToggle
          label="Contracapa Ativada"
          checked={backCover.enabled}
          onChange={(v) => onChangeBackCover({ ...backCover, enabled: v })}
        />
        <ImagePicker
          label="Imagem da Contracapa"
          value={backCover.image}
          onChange={(url) => onChangeBackCover({ ...backCover, image: url })}
          type="template"
          category="pdf-backcover"
        />
        <AdminTextarea
          label="Mensagem Final"
          value={backCover.message}
          onChange={(e) => onChangeBackCover({ ...backCover, message: e.target.value })}
          rows={3}
        />
        <AdminSelect
          label="Overlay"
          value={backCover.overlay}
          onChange={(e) => onChangeBackCover({ ...backCover, overlay: e.target.value as 'dark' | 'light' | 'none' })}
          options={[
            { value: 'dark', label: 'Escuro' },
            { value: 'light', label: 'Claro' },
            { value: 'none', label: 'Nenhum' },
          ]}
        />
      </AdminSectionCard>
    </div>
  );
}